import { TrRequired } from "./enums.js";
import { AddTextTooltipEvents, AddPkmTypeBlockPair, ColorPkmTypeBlocks, convertTMToImg, movesJSON, pkmJSON, trainersJSON, convertTrainerClassToImg, itemsJSON, abilitiesJSON, WaitFetch } from "./helper.js";

$(window).on("load", async function () {
	await WaitFetch();

	await createRouteList();

	let loadRoute = "Aquacorde Town";
	let lastRoute = localStorage.getItem("LastRoute");

	if (lastRoute)
		loadRoute = lastRoute;

	createTrainerList(loadRoute);
	document.title = `${loadRoute} - YN`;

	$(".route").on("click", function () {
		let routeName = $(this).children("p").text();
		createTrainerList(routeName);
		localStorage.setItem("LastRoute", routeName);
		document.title = `${routeName} - YN`;
		$("html, body").animate({ scrollTop: 0 }, 250);
	});
});

async function createRouteList() {
	let toAppend: string[] = [];
	let routeList = Object.entries(trainersJSON!).sort(([_a, aRouteInfo], [_b, bRouteInfo]) => aRouteInfo.RouteIdx - bRouteInfo.RouteIdx);

	routeList.forEach(([route, routeInfo]) => {
		let required = routeInfo.Required ? `<div class="svgRequiredWrapper"><svg width="32px" height="32px" viewBox="0 0 512.00 512.00" xmlns="http://www.w3.org/2000/svg" fill="#000000" transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)" stroke="#000000" stroke-width="0.00512"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="1.024"></g><g id="SVGRepo_iconCarrier"><path fill="#ffffff" d="M436.406 29.625l-18.094 42.22-48.562 5.905 42.156 25.656 1.375 13.47C367.938 90.74 302.435 75.36 214.78 82.31l-20.186-3.343-24.125-38.407.5 39.78-49.22 16.438 55.063 4.564 7.843 33.78 17.094-37.78 17.906-2.75c203.993 22.03 277.475 204.75 77.875 207.625l5.22-37.595 36.75-43.72-51.344-24.968-30.22-48.468-39.623 41.124-4.125 1.03C-8.4 163.078-31.708 304.485 98.844 376.125l-11.938 12.688L39.844 374.5l33.03 39.406-15.124 42.53 36.375-31.155 47.03 18.095-30.374-43.875 4.69-15.03c62.43 28.648 153.852 42.16 270.5 20.717-241.042 33.38-364.142-137.94-219.283-195.687l23.032 43.25-4 56.97 56.218-9.97 19.25 7.813c218.255 102.608 297.46-83.917 171.843-177.75l14.376-22.22 46.47-16.5-41.907-14.812-15.564-46.655zM34.53 79.03l4.845 26.095-19.47 22 27.22-3.25 17.563 23.344.687-29.47 24.78-17.906-33.218-1.72-22.406-19.093zm358.564 298.5l14.25 51.658-31.375 41.062 49.592-12.688 33.688 34.282-2.53-51.406 35.217-30.375-51.593 1.562-47.25-34.094z"></path></g></svg></div>` : "";

		toAppend.push(`<div class="route"><p class="routeName">${route}</p>${required}</div>`);
	});

	$("#routeList").append(toAppend.join(''));

	AddTextTooltipEvents($(".route > .svgRequiredWrapper"), (_: string) => "Mandatory Route", 150);
}

function createTrainerList(routeName: string) {
	$("#trainerList").html("");
	let toAppend: JQuery<HTMLElement>[] = [];

	let orderedTrainers = trainersJSON![routeName].Trainers.sort((x, y) => x.EncounterIdx - y.EncounterIdx);

	orderedTrainers.forEach(trEntry => {
		let $stGrid = $("<div>", { class: "singleTrainerGrid"});

		console.log(`TrName: ${trEntry.TrainerName}, TrClass: ${trEntry.TrainerClass}, TrClassType: ${trEntry.TrainerClassType}`);

		$stGrid.append(
			$("<div>", { class: trEntry.Required.toLowerCase().replace(/\s+/g, "") }).append(
				$("<p>", { text: trEntry.Required })
			)
		);

		if (trEntry.Required != TrRequired.DoublesPartner) {
			let $trMLCap =
				$("<div>", { class: "trMoneyLevelCap" }).append(
					$("<div>", { class: "trMoney" }).append(
						$("<p>", { text: `$${trEntry.Money * 10}` })
					)
				);

			if (trEntry.LevelCap) {
				$trMLCap.append(
					$("<div>", { class: "trLevelCap" }).append(
						$("<p>", { text: `Level Cap: ${trEntry.LevelCap}` })
					)
				);
			}

			$stGrid.append($trMLCap);
		}

		$stGrid.append(
			$("<div>", { class: "trClass" }).append(
				$("<img>", { src: `/images/trainers/webp/${convertTrainerClassToImg(trEntry.TrainerClassType, trEntry.IsTagBattle)}.webp`})
			)
		);

		$stGrid.append(
			$("<div>", { class: "trName" }).append(
				$("<p>", {
					text: `${trEntry.TrainerClass} ${trEntry.TrainerName == "Serena" ? "Serena/Calem" : trEntry.TrainerName}`,
					data: {
						trClass: trEntry.TrainerClass,
						trName: `${trEntry.TrainerName == "Serena" ? "Serena/Calem" : trEntry.TrainerName}`
					}
				})
			)
		);

		if (trEntry.Weather) {
			$stGrid.append(
				$("<div>", { class: `trWeather ${trEntry.Weather.toLowerCase()}` }).append(
					$("<p>", { text: trEntry.Weather })
				)
			);
		}

		$stGrid.append(
			$("<div>", { class: `trBattleType ${trEntry.BattleType.toLowerCase()}Battle` }).append(
				$("<p>", { text: `${trEntry.BattleType} Battle` })
			)
		);

		if (trEntry.Rewards.length > 0) {
			let $rewardsWrapper = $("<div>", { class: "rewardsWrapper" });

			trEntry.Rewards.forEach(reward => {
				let $rewardWrapper =
					$("<div>", { class: "rewardWrapper"}).append(
						$("<img>", { src: `/images/items/${convertTMToImg(reward).toLowerCase()}.png`})
					).append(
						$("<p>", {
							class: !reward.startsWith("TM") ? "reward" : "",
							text: reward
						})
					);

				$rewardsWrapper.append($rewardWrapper);
			});

			$stGrid.append(
				$("<div>", { class: "trRewards" }).append(
					$("<p>", { text: "Rewards:"})
				).append($rewardsWrapper)
			);
		}

		if (trEntry.Note) {
			$stGrid.append(
				$("<div>", { class: "trNote"}).append(
					$("<p>", { text: trEntry.Note})
				)
			);
		}

		for (let i = 0; i < trEntry.Pokemon.length; i++) {
			let pkmEntry = trEntry.Pokemon[i];

			let natureCSS = "neutralNature";
			if (pkmEntry.Nature.includes("+Atk"))
				natureCSS = "atkNature";
			else if (pkmEntry.Nature.includes("+Def"))
				natureCSS = "defNature";
			else if (pkmEntry.Nature.includes("+SpA"))
				natureCSS = "spaNature";
			else if (pkmEntry.Nature.includes("+SpD"))
				natureCSS = "spdNature";
			else if (pkmEntry.Nature.includes("+Spe"))
				natureCSS = "speNature";

			let displayName = pkmEntry.Name;
			let nameForTypes = pkmEntry.Name;
			let forme = pkmEntry.Forme;
			let megaAbility = "";
			let megaFormList = ["-mega", "-mega-x", "-mega-y"];
			let heldItem = pkmEntry.HeldItem;

			if (pkmEntry.Forme) {
				forme= `-${forme}`;
				nameForTypes = displayName += forme;

				if (pkmJSON![pkmEntry.Name].SpeciesIdx == 710 || pkmJSON![pkmEntry.Name].SpeciesIdx == 711) {
					displayName = pkmJSON![pkmEntry.Name].SpeciesIdx == 711 ? `Gourgeist${forme}` : `Pumpkaboo${forme}`;
					forme = "";
				}
				
				forme = forme.toLowerCase();
			}

			if (heldItem.startsWith("Megite")) {
				forme = `-Mega`;
				displayName = `Mega ${pkmEntry.Name}`;
				if (heldItem == "Megite X" && (pkmEntry.Name == "Charizard" || pkmEntry.Name == "Mewtwo")) {
					forme = `-Mega-X`;
					displayName = `Mega ${pkmEntry.Name} X`;
				}
				else if (heldItem == "Megite Y" && (pkmEntry.Name == "Charizard" || pkmEntry.Name == "Mewtwo")) {
					forme = `-Mega-Y`;
					displayName = `Mega ${pkmEntry.Name} Y`;
				}

				nameForTypes += forme;
				forme = forme.toLowerCase();
				megaAbility = `<p> / </p><p class="ability">${pkmJSON![nameForTypes].Ability1}</p>`;
			}

			let $trPkm = $("<div>", { class: `pkm${i}${trEntry.Pokemon.length > 6 ? " tag44" : (trEntry.IsTagBattle && i == 3 ? " tagBattle" : "")}` });

			$trPkm.append(
				$("<div>", { class: "pkmImgWrapper" }).append(
					$("<a>", { href: `/dex/${pkmEntry.Name}`}).append(
						$("<img>", { src: `/images/pkm/official-artwork/webp/${pkmJSON![pkmEntry.Name].SpeciesIdx}${forme}.webp`})
					)
				)
			);

			$trPkm.append(
				$("<h5>", { text: displayName })
			);

			$trPkm.append(
				$("<div>", { class: "flex"}).append(
					AddPkmTypeBlockPair(nameForTypes)
				)
			);

			$trPkm.append(
				$("<p>", { text: `Level ${pkmEntry.Level}`})
			);

			$trPkm.append($("<hr>"));

			$trPkm.append(
				$("<div>", { class: "abilityWrapper" }).append(
					$("<p>", { class: "ability", text: pkmEntry.Ability})
				).append(megaAbility)
			);

			let $item = $("<div>", { class: "itemImgWrapper" });

			if (heldItem) {
				$item.append(
					$("<img>", { src: `/images/items/${heldItem.toLowerCase()}.png`})
				);
			}

			$item.append(
				$("<p>", {
					class: heldItem ? "item" : "",
					text: heldItem ? heldItem : "No Item"
				})
			);

			$trPkm.append($item);

			$trPkm.append(
				$("<div>", { class: natureCSS }).append(
					$("<p>", { text: pkmEntry.Nature })
				)
			);

			$trPkm.append(
				// 25 orange, 130 green
				$("<div>", { class: "ivs", style: `background-color: hsl(${((pkmEntry.IVs / 31) * 105) + 25}, 70%, 65%)` }).append(
					$("<p>", { text: `IVs: ${pkmEntry.IVs}` })
				)
			);

			$trPkm.append($("<hr>"));

			for (let j = 0; j < pkmEntry.Moves.length; j++) {
				if (pkmEntry.Moves[j] == "")
					break;

				$trPkm.append(
					$("<div>", { class: "moveTypeWrapper" }).append(
						$("<img>", { src: `/images/typeIcons/sv/${movesJSON![pkmEntry.Moves[j]].Type.toLowerCase()}.png` })
					).append(
						$("<img>", { src: `/images/categoryIcons/${movesJSON![pkmEntry.Moves[j]].Category.toLowerCase()}.png`})
					).append(
						$("<p>", { text: pkmEntry.Moves[j] })
					)
				);
			}

			if (trEntry.Pokemon.length > 6 && i < 4) {
				$trPkm.append(
					$("<div>", { class: "borderBottom" })
				);
			}

			$stGrid.append($trPkm);
		}

		toAppend.push($stGrid);
	});

	$("#trainerList").append(toAppend);
	ColorPkmTypeBlocks();

	$("#routeList").children().removeClass("activeRoute");
	$(".route").filter((_, ele) => $(ele).text() == routeName).addClass("activeRoute");

	$(".trName").each((_, ele) => {
		let p = $(ele).children("p");

		if (p.innerWidth()! > 250) {
			let trClass = p.data("trClass");
			let trName = p.data("trName");
			p.html(`${trClass}<br>${trName}`);
		}
	});

	// addTooltipEvents($(".tripleBattle"), _ => "Be Careful!<br><br>The order is reversed here. The first Pokemon shown will be on the <i>right</i>, while the third Pokemon will be on the <i>left</i>!", 300, "#000");

	AddTextTooltipEvents($(".reward"), ($item: JQuery<HTMLParagraphElement>) => itemsJSON![$item.text()].Description, 350, "#333");
	AddTextTooltipEvents($(".item"), ($item: JQuery<HTMLParagraphElement>) => itemsJSON![$item.text()].Description, 350);
	AddTextTooltipEvents($(".ability"), ($ability: JQuery<HTMLParagraphElement>) => abilitiesJSON![$ability.text()].Description, 350);
}